import {
  INCREMENT_CART,
  DECREMENT_CART,
  START_LOADING,
  END_LOADING,
  START_LOADING1,
  END_LOADING1,
  END_LOADING1_CUSTOM,
  START_LOADING1_CUSTOM,
  CHECKOUT_INCREMENT_CART,
  DECREMENT_CART_CHECKOUT,
  CLEAR_CHECKOUT,
  SEARCH_CART_ORDER,
  DELETE_CART_CHECKOUT,
  EditOrder,
  MENUSETTINGSWIPING,
  MENUPRODUCTSWIPING,
  USERMENUS,
  CREATE_USERMENUS,
  USERPRODUCTS,
  CREATE_PRODUCT,
  UPDATE_MENU,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  CART_ORDERS,
  UPDATECARTORDER,
  CREATE_CART_ORDERS,
  DELETECARTORDER,
  UPDATE_PRODUCT_ITEMS,
  UPDATE_PRODUCT_ITEMS_FAIL,
  CREATE_CART_ORDERS_PRINT,
  DELETE_MENU,
  DAYCARTSDATA,
  MONTHCARTSDATA,
  YEARCARTSDATA,
  CUSTOMCARTSDATA,
  WAITERS_ACCOUNTS,
  CUSTOMCARTSACCOUNTDATA,
  SKT_CUSTOMCART_DELETE,
  SKT_CUSTOMCART_UPDATE,
  CART_ORDERS_PAGI_SUCCESS,
  UPDATE_ORDER_STATUS,
} from "../redux-thunk/ReducerCaseType";

import {
  createPost,
  fetchPosts,
  UpdatePost,
  SWAPPOST,
  createProduct,
  fetchProducts,
  UpdateProduct,
  DeleteProduct,
  Deletepost,
  DeleteProducts,
  CreateCart,
  FetchCarts,
  UpdateCart,
  DeleteOrder,
  FetchCartsWITHTIME,
  FetchCartsWITHTimeMonth,
  FetchCartsWITHTimeYear,
  CartFinds,
  FetchCartsWITHTIMECustom,
  FetchAccountCartsWITHTIMECustom,
  OrderABI,
  DeleteOrderAndUpdateProduct,
  UpdateOrderByPraID,
  GetwaiterAcconts,
  FetchCartsWITHTIMECustomAdmin,
  GETCARTSEARCH,
  SWAPPOSTPRODUCT,
    updateOrderStatus, 

} from "../API/Api";
import { toast } from "react-toastify";

////////////////////////////////////////////////  with backend working /////////////////////////////////////////////////////////////////////////////////////

export const CreateMenuItem = (Data, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await createPost(Data);
      if (value.status === 201) {
        setTimeout(resolve("Menu item added successfully."), 1000);
      }
      dispatch({ type: CREATE_USERMENUS, payload: value.data });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to add a new menu item."),
          1000
        );
      } else if (error.message === "Request failed with status code 409") {
        setTimeout(
          reject("Unable to create menu item. Please try again later."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Menu item creation is pending",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const EditMenuItem = (DATA, navigate) => async (dispatch) => {
  const id = DATA.id;
  const updatedpost = { name: DATA.name, img: DATA.img };

  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await UpdatePost(id, updatedpost);
      const data = value.data;

      if (value.status === 201) {
        setTimeout(resolve(`Menu Edited successfully `), 1000);
      }
      dispatch({ type: UPDATE_MENU, payload: data });
      // navigate('/dashboard/home')
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to edit this menu item."),
          1000
        );
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            "Unable to update the menu item due to a server issue. Please try again later."
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject("The menu item you are trying to edit could not be found."),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to update the menu item. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Updating menu item...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const FetchPOST = (navigate) => async (dispatch) => {
  const usermenu = JSON.parse(localStorage.getItem("usermenu"));
  const userproduct = JSON.parse(localStorage.getItem("userproduct"));
  const waitersAcc = JSON.parse(localStorage.getItem("waiteracc"));
  // console.log(usermenu);
  // console.log(userproduct);

  try {
    dispatch({ type: START_LOADING });
    const value = await fetchPosts();
    const data = value.data;
    const value1 = await fetchProducts();
    const data1 = value1.data;
    const value5 = await GetwaiterAcconts();
    const data5 = value5.data;
    console.log(data5);

    dispatch({ type: USERMENUS, payload: data });
    dispatch({ type: USERPRODUCTS, payload: data1 });
    dispatch({ type: WAITERS_ACCOUNTS, payload: data5 });
    localStorage.setItem("usermenu", JSON.stringify(data));
    localStorage.setItem("userproduct", JSON.stringify(data1));
    localStorage.setItem("waiteracc", JSON.stringify(data5));
    dispatch({ type: END_LOADING });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access this data.", {
        position: "top-center",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Menu data could not be retrieved. Please try again later.", {
        position: "top-center",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // progress: 1,
      });
    } else if (error.message === "Request failed with status code 504") {
      toast.error("Your session has expired. Please log in again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // progress: 1,
      });
      // navigate('/login');
      // navigate('/');
      // localStorage.clear();
    } else {
      toast.error("Unable to fetch menu data at this time. Please try again.", {
        position: "top-center",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // progress: 1,
      });
    }
  }
};

export const DELETEMENU = (id, DeletePro, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const { data } = await DeleteProducts(id, DeletePro);
      const value = await Deletepost(id);
      if (value.status === 201) {
        setTimeout(
          resolve("Menu and associated products deleted successfully."),
          1000
        );
      }
      dispatch({ type: DELETE_MENU, payload: id });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to delete this menu."),
          1000
        );
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            "Unable to delete menu due to a server issue. Please try again later."
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject("The menu item you are trying to delete could not be found."),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to delete the menu. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Deleting menu...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const MenuSettingSwiper = (swipeMenu) => async (dispatch) => {
  const id = swipeMenu.draggableId;
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await SWAPPOST(swipeMenu, id);
      const data = value.data;

      if (value.status === 202) {
        setTimeout(resolve("Menu reordered successfully."), 1000);
      }
      // SWAPPOST
      dispatch({ type: MENUSETTINGSWIPING, payload: data });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to reorder this menu."),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            "Unable to reorder menu at this time. Please try again later."
          ),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to reorder the menu. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Reordering menu...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const MenuSettingSwiperProduct = (swipeMenu) => async (dispatch) => {
  const id = swipeMenu.draggableId;
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await SWAPPOSTPRODUCT(swipeMenu, id);
      const data = value.data;

      if (value.status === 202) {
        setTimeout(resolve("Product reordered successfully."), 1000);
      }

      // Dispatch the swiping action
      dispatch({ type: MENUPRODUCTSWIPING, payload: data });

      // Force a complete refresh of products for all roles
      try {
        const freshProducts = await fetchProducts();
        // Update both the products list and any cached versions
        dispatch({ type: USERPRODUCTS, payload: freshProducts.data });
        localStorage.setItem("userproduct", JSON.stringify(freshProducts.data));
      } catch (fetchError) {
        console.error("Failed to refresh products:", fetchError);
        // Even if refresh fails, ensure the UI updates with the swapped data
        dispatch({ type: USERPRODUCTS, payload: data });
      }
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to reorder this product."),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            "Unable to reorder product at this time. Please try again later."
          ),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to reorder the product. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Reordering product...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const CreateProductItem = (Data, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await createProduct(Data);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(resolve("Product added successfully."), 1000);
      }
      dispatch({ type: CREATE_PRODUCT, payload: data });
      // navigate('/dashboard/home')
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to add a product."),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            "Unable to create the product at this time. Please try again."
          ),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to add the product. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Adding product...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const FetchPRODUCT = () => async (dispatch) => {
  // const resolveAfter3Sec = new Promise(async (resolve, reject) => {
  try {
    dispatch({ type: START_LOADING });
    const value = await fetchProducts();
    const data = value.data;
    console.log(data);
    // if (value.status == 200) {
    //     setTimeout(resolve(`status:${value.status}: Product Data successfully GET`), 1000)
    // }

    dispatch({ type: USERPRODUCTS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // setTimeout(reject( "You do not have permission to access products."), 1000)
    } else if (error.message === "Request failed with status code 404") {
      toast.error(
        "Unable to retrieve product data at this time. Please try again later.",
        {
          position: "top-center",
          autoClose: 50,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          // progress: 1,
        }
      );
    } else {
      toast.error("Failed to load products. Please try again.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const EditProductItem = (DATA, navigate) => async (dispatch) => {
  const id = DATA.id;
  const updatedpost = {
    name: DATA.name,
    img: DATA.img,
    price: Number(DATA.price),
    quantity: Number(DATA.quantity),
    menuname: DATA.menuname,
    menuid: DATA.menuid,
    inventryquantity: Number(DATA.quantity),
    changingquantity: Number(DATA.quantity),
  };

  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await UpdateProduct(id, updatedpost);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(resolve("Product updated successfully."), 1000);
      }
      dispatch({ type: UPDATE_PRODUCT, payload: data });
      // navigate('/dashboard/home')
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to edit this product."),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            "Unable to find the product to edit. Please check the product ID."
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            "Product could not be updated at this time. Please try again."
          ),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to update the product. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Updating product...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const DELETEPRODUCT = (id, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await DeleteProduct(id);
      if (value.status === 200) {
        setTimeout(resolve("Product deleted successfully."), 1000);
      }
      dispatch({ type: DELETE_PRODUCT, payload: id });
      // navigate('/dashboard/home')
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(
          reject("You do not have permission to delete this product."),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            "Unable to find the product to delete. Please check the product ID."
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            "Product could not be deleted at this time. Please try again."
          ),
          1000
        );
      } else {
        setTimeout(
          reject("Failed to delete the product. Please try again."),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Deleting product...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const itemCardQuantityIncrement = (Recipe) => async (dispatch) => {
  try {
    dispatch({ type: INCREMENT_CART, payload: Recipe });
  } catch (error) {}
};

export const itemCardQuantityDecrement = (Recipe) => async (dispatch) => {
  try {
    dispatch({ type: DECREMENT_CART, payload: Recipe });
  } catch (error) {}
};

export const itemCardQuantityIncrementCheckout =
  (Recipe) => async (dispatch) => {
    try {
      dispatch({ type: CHECKOUT_INCREMENT_CART, payload: Recipe });
    } catch (error) {}
  };

export const itemCardQuantityDecrementCheckout =
  (Recipe) => async (dispatch) => {
    try {
      dispatch({ type: DECREMENT_CART_CHECKOUT, payload: Recipe });
    } catch (error) {}
  };

export const itemCardQuantityDeleteCheckout = (Recipe) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CART_CHECKOUT, payload: Recipe });
    toast.error("Item removed successfully!", {
      position: "top-center",
      autoClose: 50,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  } catch (error) {}
};

export const ClearOrder = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_CHECKOUT });
  } catch (error) {
    toast.error("Something went wrong while deleting the item.");
  }
};

//////////////CART////////////////////
async function persistSettledStatus(cart) {
  if (!cart?._id) {
    return { ...cart, orderStatus: "settled" };
  }
  try {
    const res = await updateOrderStatus(cart._id, { orderStatus: "settled" });
    return { ...(res?.data || cart), orderStatus: "settled" };
  } catch (error) {
    return { ...cart, orderStatus: "settled" };
  }
}

export const BillOrders = (Order, setpopupOn, authData) => async (dispatch) => {
  console.log(Order);
  Order = { ...Order, orderStatus: "settled" };

  // Handle non-POSID case (regular orders)
  if (authData.result.posid === null) {
    const isOnline = navigator.onLine;

    // Offline case - queue the order
    if (!isOnline) {
      const offlineOrders =
        JSON.parse(localStorage.getItem("offlineOrders")) || [];
      Order.paymentItems.sort((a, b) => b.price - a.price);
      offlineOrders.push(Order);

      localStorage.setItem("offlineOrders", JSON.stringify(offlineOrders));
      dispatch({ type: CREATE_CART_ORDERS_PRINT, payload: Order });
      setpopupOn(true);
      toast.info("Order queued. Will be processed when back online.", {
        position: "top-center",
        autoClose: 1000,
      });
      return;
    } else {
      try {
        const value = await CreateCart(Order);
        const data = value.data;
        const settledCart = await persistSettledStatus(data.cart);

        dispatch({ type: CREATE_CART_ORDERS, payload: settledCart });
        dispatch({ type: UPDATE_PRODUCT_ITEMS, payload: data.product });
        dispatch({ type: CREATE_CART_ORDERS_PRINT, payload: settledCart });
        setpopupOn(true);

        const offlineOrders =
          JSON.parse(localStorage.getItem("offlineOrders")) || [];
        if (offlineOrders.length > 0) {
          const processedOrders = [];

          for (const queuedOrder of offlineOrders) {
            try {
              const queuedValue = await CreateCart(queuedOrder);
              const settledQueued = await persistSettledStatus(
                queuedValue.data.cart
              );
              processedOrders.push(settledQueued);
            } catch (error) {
              console.error("Failed to process offline order:", error.message);
              toast.error(
                `Failed to process queued order. Error: ${error.message}`,
                {
                  position: "top-center",
                  autoClose: 1000,
                }
              );
            }
          }

          localStorage.removeItem("offlineOrders");

          try {
            const freshOrders = await FetchCarts(1);
            dispatch({ type: CART_ORDERS, payload: freshOrders.data });
          } catch (fetchError) {
            console.error("Failed to refresh orders:", fetchError);
          }

          toast.success("Queued orders processed successfully.", {
            position: "top-center",
            autoClose: 1000,
          });
        }
      } catch (error) {
        dispatch({
          type: UPDATE_PRODUCT_ITEMS_FAIL,
          payload: Order.paymentItems,
        });
        if (error.message === "Request failed with status code 402") {
          toast.error( "You do not have permission to access products.", {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else if (error.message === "Request failed with status code 409") {
          toast.error("Something went wrong while placing your order. Please try again.", {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      }
    }
  }
  // Handle POSID case (special tax processing)
  else {
    let saveValue = [];
    let saveCart = [];

    // Apply tax calculations using the same rate as checkout (8% card, 16% cash)
    const appliedTaxRate = Order.payingThroughCard ? 8 : 16;
    const OrderPay = Order.paymentItems.map((item) => {
      const textChar = item.TaxCharged + appliedTaxRate;
      const TaxP = Number(((item.price * appliedTaxRate) / 100).toFixed(2));
      const PricWithTax = Number((item.price + TaxP).toFixed(2));

      return {
        ...item,
        TaxRate: textChar,
        TaxCharged: TaxP,
        price: PricWithTax,
      };
    });
    Order = { ...Order, paymentItems: OrderPay };

    try {
      const valueX = await CreateCart(Order);
      const dataX = valueX.data;
      const CARTX = dataX.cart;
      saveValue.push(valueX);
      saveCart.push(CARTX);

      const PRADATA = {
        InvoiceNumber: "",
        POSID: authData.result.posid,
        USIN: dataX.cart._id,
        DateTime: dataX.cart.createdAt,
        BuyerPNTN: "1234567-8",
        BuyerCNIC: "12345-1234567-8",
        BuyerName: dataX.cart.CustmerName,
        BuyerPhoneNumber: "0000-0000000",
        TotalBillAmount: dataX.cart.FinalBill,
        TotalQuantity: dataX.cart.cartItems.reduce(
          (total, item) => total + item.quantity,
          0
        ),
        TotalSaleValue: dataX.cart.totalBill,
        TotalTaxCharged: dataX.cart.TotalTaxCharged,
        TaxRate: appliedTaxRate,
        Discount: dataX.cart?.Discount || 0,
        FurtherTax: 0.0,
        PaymentMode: 1,
        RefUSIN: null,
        InvoiceType: 1,
        ordernumber: dataX.cart.ordernumber,
        creator: dataX.cart.creator,
        totalBill: dataX.cart.totalBill,
        MergeCarts: dataX.cart.MergeCarts,
        Items: dataX.cart.cartItems.map((item) => ({
          ...item,
          TaxRate: item.TaxRate,
          SaleValue: item.OneitemPrice,
          TotalAmount: item.price,
          TaxCharged: item.TaxCharged,
          InvoiceType: 1,
          ItemCode: item._id,
          PCTCode: item.PCTCode,
          ItemName: item.name,
        })),
      };

      const dD = await OrderABI(PRADATA);
      const dDANS = dD.data;

      if (
        valueX.status === 200 &&
        dD.data.Errors == null &&
        dD.data.Code == 100
      ) {
        const value2 = await UpdateOrderByPraID(dDANS.InvoiceNumber, CARTX);

        if (value2.status === 200) {
          const settledPraCart = await persistSettledStatus(value2.data);
          dispatch({ type: CREATE_CART_ORDERS, payload: settledPraCart });
          dispatch({ type: UPDATE_PRODUCT_ITEMS, payload: dataX.product });
          dispatch({ type: CREATE_CART_ORDERS_PRINT, payload: settledPraCart });
          setpopupOn(true);
        } else {
          toast.error("status:402 order placed but ID not stored in DB", {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } else if (dD.data.Errors !== null) {
        const value4 = await DeleteOrderAndUpdateProduct(CARTX);
        dispatch({ type: UPDATE_PRODUCT_ITEMS, payload: value4.data.product });
        toast.error("Your order went through, but we’re having trouble confirming it. Please try again.", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        dispatch({
          type: UPDATE_PRODUCT_ITEMS_FAIL,
          payload: Order.paymentItems,
        });
        toast.error( "You do not have permission to access products.", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (error.message === "Request failed with status code 409") {
        dispatch({
          type: UPDATE_PRODUCT_ITEMS_FAIL,
          payload: Order.paymentItems,
        });
        toast.error("Something went wrong while placing this order. please try later", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (error.code === "ERR_NETWORK") {
        if (saveValue.length !== 0) {
          const CARTsaveCart = saveCart[0];
          const value4 = await DeleteOrderAndUpdateProduct(CARTsaveCart);
          dispatch({
            type: UPDATE_PRODUCT_ITEMS,
            payload: value4.data.product,
          });
          toast.error(`Something went wrong while placing order. Check your network.`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          dispatch({
            type: UPDATE_PRODUCT_ITEMS_FAIL,
            payload: Order.paymentItems,
          });
          toast.error(`Something went wrong while placing order. Check your network.`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } else {
        dispatch({
          type: UPDATE_PRODUCT_ITEMS_FAIL,
          payload: Order.paymentItems,
        });
        toast.error("Something went wrong while placing order.", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  }
};
export const FetchOrders = (page) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const value = await FetchCarts(page);
    const data = value.data;

    dispatch({ type: CART_ORDERS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while fetching orders.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const FetchOrdersPagination = (page) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const value = await FetchCarts(page);
    const data = value.data;

    // dispatch({ type: CART_ORDERS, payload: data })
    dispatch({ type: CART_ORDERS_PAGI_SUCCESS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while fetching orders.Please try again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const FetchCartsSearch = (Searchdata) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const value = await GETCARTSEARCH(Searchdata);
    const data = value.data;
    dispatch({ type: CART_ORDERS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while fetching orders.Please try again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error("Something went wrong while fetching orders.Please try again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const fetchCartsSearchPaginations = (Searchdata) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const value = await GETCARTSEARCH(Searchdata);
    const data = value.data;
    dispatch({ type: CART_ORDERS_PAGI_SUCCESS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while fetching orders.Please try again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error("Something went wrong while fetching orders.Please try again.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const FetchOrderBySearch = (SearchQuery) => async (dispatch) => {
  // try {
  //     dispatch({type : START_LOADING})
  //     const value = await CartFinds(SearchQuery);
  //     const data = value.data;

  //     // dispatch({type:SEARCH_POST,payload:data})
  //     dispatch({type : END_LOADING})
  // } catch (error) {

  // }

  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await CartFinds(SearchQuery);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve("Your order details have been loaded successfully!"),
          1000
        );
      }

      dispatch({ type: SEARCH_CART_ORDER, payload: data });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject( "You do not have permission to access products."), 1000);
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            `Failed to fetch order details due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to fetch order detail.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Loading order details...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

// ////////////////////////////Deleting///////////////////////////////////////////
export const EditOrderOFOrderDetail = (Edit) => async (dispatch) => {
  try {
    Edit.navigate("/dashboard/home");
    dispatch({ type: EditOrder, payload: Edit.editOrder });
  } catch (error) {}
};
////////////////////////////////////////////////////////////////////////////////////

export const UpdateBillOrder = (order, setpopupOn) => async (dispatch) => {
  const id = order.id;
  const updatedcart = {
    CustmerName: order.CustmerName,
    cartItems: order.paymentItems,
    ItemCount: order.ItemCount,
    totalBill: order.totalBill,
    ordernumber: order.ordernumber,
    Discount: order.Discount,
    FinalBill: order.FinalBill,
    mergeNo: order.mergeNo,
    OrderReciverid: order.OrderReciverid,
    OrderReciverName: order.OrderReciverName,
  };
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await UpdateCart(id, updatedcart);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`Order updated successfully`),
          1000
        );
      }
      // dispatch({ type: UPDATECARTORDER, payload: data })
      // dispatch({ type: CREATE_CART_ORDERS_PRINT, payload: data })

      dispatch({ type: UPDATECARTORDER, payload: data.updatedCart });
      dispatch({ type: SKT_CUSTOMCART_UPDATE, payload: data.updatedCart });
      dispatch({ type: UPDATE_PRODUCT_ITEMS, payload: data.product });
      dispatch({ type: CREATE_CART_ORDERS_PRINT, payload: data.updatedCart });
      setpopupOn(true);
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject( "You do not have permission to access products."), 1000);
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(
          reject(
            `Order update failed. Please verify the entered details.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(reject(`Failed to update order.please try again.`), 1000);
      }
    }
  });
  toast.promise(resolveAfter3Sec, {
    pending: "Updating order...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const DELETEORDER = (id) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await DeleteOrder(id);

      if (value.status === 200) {
        setTimeout(
          resolve(`Order Deleted successfully`),
          1000
        );
      }
      dispatch({ type: DELETECARTORDER, payload: id });
      dispatch({ type: SKT_CUSTOMCART_DELETE, payload: id });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject( "You do not have permission to access products."), 1000);
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(
            `Failed to delete order due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to delete order. Please try again.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Deleting order...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};
// Add this with your other cart action creators in ApiActionMenu.js
// In ApiActionMenu.js - update the action creator
export const updateOrderStatusAction = (orderId, statusData) => async (dispatch) => {
  try {
    const value = await updateOrderStatus(orderId, statusData);
    const data = value.data;
    
    // Use the constant instead of string
    dispatch({ 
      type: UPDATE_ORDER_STATUS, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error("Failed to update order status:", error);
    throw error;
  }
};
export const GetDetailOfTime = (TIME) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING1 });
    const value = await FetchCartsWITHTIME(TIME);
    const data = value.data;
    const value1 = await FetchCartsWITHTimeMonth(TIME);
    const data1 = value1.data;
    const value2 = await FetchCartsWITHTimeYear(TIME);
    const data2 = value2.data;

    dispatch({ type: DAYCARTSDATA, payload: data });
    dispatch({ type: MONTHCARTSDATA, payload: data1 });
    dispatch({ type: YEARCARTSDATA, payload: data2 });
    dispatch({ type: END_LOADING1 });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while loading data. Please refresh.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const GetDetailOfTimeCustom = (TIME) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING1 });
    const value = await FetchCartsWITHTIMECustom(TIME);
    const data = value.data;

    dispatch({ type: CUSTOMCARTSDATA, payload: data });
    dispatch({ type: END_LOADING1 });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while loading data. Please refresh.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const GetDetailOfTimeCustomAdmin = (TIME) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING1 });
    const value = await FetchCartsWITHTIMECustomAdmin(TIME);
    const data = value.data;

    dispatch({ type: CUSTOMCARTSDATA, payload: data });
    dispatch({ type: END_LOADING1 });
  } catch (error) {
    if (error.message === "Request failed with status code 402") {
      toast.error("You do not have permission to access products.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message === "Request failed with status code 404") {
      toast.error("Something went wrong while loading data. Please refresh.", {
        position: "top-center",
        autoClose: 50,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const GetDetailOfAccountOrdersTimeCustom =
  (TIME) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING1_CUSTOM });
      const value = await FetchAccountCartsWITHTIMECustom(TIME);
      const data = value.data;

      console.log(data);
      dispatch({ type: CUSTOMCARTSACCOUNTDATA, payload: data });
      dispatch({ type: END_LOADING1_CUSTOM });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        toast.error("You do not have permission to access products.", {
          position: "top-center",
          autoClose: 50,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (error.message === "Request failed with status code 404") {
        toast.error("Something went wrong while loading data. Please refresh.", {
          position: "top-center",
          autoClose: 50,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };
